// extracted by css-extract-rspack-plugin
export default {"swatch":"axis-heading-module__swatch__scNZi"};